import "./Footer.scss";
import { Link } from "react-router-dom";
import Logo from "../../assets/logo.webp";

function Footer() {
  return (
    <div className='Footer'>
      <div className='upper_wrapper'>
        <div className='second_upper_wrapper'>
          <div className='card'>
            <div className='image_wrapper'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='25'
                height='26'
                viewBox='0 0 25 26'
                fill='none'>
                <path
                  d='M13.5747 23.1434C13.7104 23.1381 13.8458 23.1603 13.9727 23.2086C14.0996 23.2569 14.2155 23.3303 14.3133 23.4245C14.4112 23.5186 14.489 23.6315 14.5422 23.7565C14.5954 23.8815 14.6228 24.0159 14.6228 24.1517C14.6228 24.2875 14.5954 24.4219 14.5422 24.5468C14.489 24.6718 14.4112 24.7847 14.3133 24.8788C14.2155 24.973 14.0996 25.0464 13.9727 25.0947C13.8458 25.143 13.7104 25.1652 13.5747 25.1599C13.3071 25.1599 13.0504 25.0536 12.8612 24.8644C12.672 24.6752 12.5657 24.4185 12.5657 24.1509C12.5657 23.8833 12.672 23.6266 12.8612 23.4374C13.0504 23.2482 13.3071 23.1434 13.5747 23.1434ZM10.0453 22.1343C10.181 22.1291 10.3164 22.1512 10.4433 22.1995C10.5702 22.2479 10.6861 22.3213 10.7839 22.4154C10.8818 22.5096 10.9596 22.6225 11.0128 22.7475C11.066 22.8724 11.0934 23.0068 11.0934 23.1426C11.0934 23.2784 11.066 23.4128 11.0128 23.5378C10.9596 23.6627 10.8818 23.7756 10.7839 23.8698C10.6861 23.9639 10.5702 24.0374 10.4433 24.0857C10.3164 24.134 10.181 24.1562 10.0453 24.1509C9.78465 24.1408 9.53803 24.0302 9.35719 23.8422C9.17634 23.6542 9.07533 23.4035 9.07533 23.1426C9.07533 22.8818 9.17634 22.631 9.35719 22.4431C9.53803 22.2551 9.78465 22.1444 10.0453 22.1343ZM17.1041 22.1343C17.2398 22.1291 17.3752 22.1512 17.5021 22.1995C17.629 22.2479 17.7449 22.3213 17.8427 22.4154C17.9406 22.5096 18.0184 22.6225 18.0716 22.7475C18.1248 22.8724 18.1522 23.0068 18.1522 23.1426C18.1522 23.2784 18.1248 23.4128 18.0716 23.5378C18.0184 23.6627 17.9406 23.7756 17.8427 23.8698C17.7449 23.9639 17.629 24.0374 17.5021 24.0857C17.3752 24.134 17.2398 24.1562 17.1041 24.1509C16.8434 24.1408 16.5968 24.0302 16.416 23.8422C16.2351 23.6542 16.1341 23.4035 16.1341 23.1426C16.1341 22.8818 16.2351 22.631 16.416 22.4431C16.5968 22.2551 16.8434 22.1444 17.1041 22.1343ZM13.5747 7.00617C17.3023 7.00617 19.4187 9.38583 19.7258 12.2617H19.8196C22.2189 12.2617 24.1644 14.133 24.1644 16.4416C24.1644 18.7502 22.2189 20.6215 19.8196 20.6215H7.32981C4.93048 20.6215 2.985 18.7502 2.985 16.4416C2.985 14.133 4.93048 12.2617 7.32981 12.2617H7.4236C7.73222 9.36616 9.84562 7.00617 13.5747 7.00617ZM13.5747 8.51898C11.0786 8.51898 8.90465 10.4403 8.90465 13.0952C8.90465 13.5158 8.52039 13.8456 8.08016 13.8456H7.24811C5.72925 13.8441 4.49782 15.0241 4.49782 16.4764C4.49782 17.9287 5.72925 19.1087 7.24811 19.1087H19.9013C21.4202 19.1087 22.6516 17.9287 22.6516 16.4764C22.6516 15.0241 21.4202 13.8441 19.9013 13.8441H19.0692C18.629 13.8456 18.2448 13.5158 18.2448 13.0952C18.2448 10.407 16.0693 8.51898 13.5747 8.51898ZM2.68698 11.0908C2.74514 11.2585 2.74245 11.4413 2.67939 11.6073C2.61634 11.7732 2.49692 11.9117 2.34206 11.9985L2.21801 12.0529L1.00624 12.4705C0.827417 12.533 0.631619 12.5262 0.457573 12.4514C0.283527 12.3765 0.143906 12.2391 0.0663255 12.0662C-0.0112555 11.8934 -0.0211477 11.6977 0.0386052 11.5179C0.0983581 11.3381 0.223405 11.1873 0.389015 11.0953L0.513065 11.0408L1.72634 10.6233C1.91593 10.5583 2.12358 10.5711 2.3037 10.659C2.48381 10.747 2.62167 10.9028 2.68698 11.0923M10.4281 4.73695C10.9318 4.98202 11.3736 5.30123 11.7502 5.67489C11.136 5.80046 10.5612 5.99258 10.0317 6.2422C9.34844 5.83094 8.54379 5.66915 7.75468 5.78435C6.96558 5.89955 6.24077 6.28463 5.7036 6.87405C5.16643 7.46347 4.8501 8.22082 4.80844 9.0172C4.76678 9.81358 5.00236 10.5998 5.4751 11.2421C4.97587 11.3903 4.5069 11.6066 4.07574 11.8774C3.49086 10.9663 3.22002 9.88898 3.3045 8.80961C3.38899 7.73025 3.82417 6.70814 4.54369 5.89916C5.2632 5.09018 6.22756 4.53872 7.28969 4.32888C8.35182 4.11905 9.45344 4.26236 10.4265 4.73695M1.34511 4.99413L1.47219 5.04254L2.62495 5.60379C2.79489 5.6864 2.92776 5.82963 2.99741 6.00528C3.06705 6.18093 3.06843 6.37629 3.00127 6.55291C2.93412 6.72953 2.80329 6.87462 2.63453 6.95962C2.46577 7.04463 2.27131 7.06339 2.08942 7.01222L1.96083 6.96381L0.809577 6.40256C0.639637 6.31994 0.50677 6.17672 0.437125 6.00107C0.367479 5.82541 0.3661 5.63005 0.433257 5.45343C0.500414 5.27682 0.631244 5.13173 0.8 5.04672C0.968757 4.96172 1.16322 4.94296 1.34511 4.99413ZM12.0452 1.40119C12.2045 1.4789 12.3315 1.61008 12.4039 1.77182C12.4763 1.93356 12.4897 2.11561 12.4416 2.28619L12.3932 2.41326L11.8319 3.56603C11.7493 3.73597 11.6061 3.86884 11.4305 3.93848C11.2548 4.00813 11.0594 4.00951 10.8828 3.94235C10.7062 3.87519 10.5611 3.74436 10.4761 3.57561C10.3911 3.40685 10.3723 3.21239 10.4235 3.03049L10.4719 2.9019L11.0332 1.74914C11.0767 1.65961 11.1376 1.57957 11.2121 1.5136C11.2867 1.44763 11.3736 1.39704 11.4677 1.36471C11.5619 1.33238 11.6615 1.31897 11.7609 1.32523C11.8602 1.33149 11.9559 1.3573 12.0452 1.40119ZM6.3132 1.35278L6.36917 1.47683L6.78671 2.69011C6.84808 2.8687 6.84044 3.0638 6.76526 3.23704C6.69009 3.41028 6.55283 3.54914 6.38047 3.62631C6.20811 3.70349 6.01312 3.7134 5.83382 3.65409C5.65453 3.59478 5.5039 3.47055 5.41156 3.30582L5.35558 3.18177L4.93956 1.97001C4.87914 1.79183 4.8873 1.59754 4.96243 1.42505C5.03756 1.25257 5.17427 1.11427 5.34588 1.03716C5.51749 0.960045 5.71168 0.949655 5.89054 1.00801C6.0694 1.06637 6.22009 1.18929 6.3132 1.35278Z'
                  fill='url(#paint0_linear_486_3098)'
                />
                <defs>
                  <linearGradient
                    id='paint0_linear_486_3098'
                    x1='12.0822'
                    y1='0.970703'
                    x2='12.0822'
                    y2='25.1607'
                    gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#DEC067' />
                    <stop offset='1' stopColor='#EBDDB1' />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <p className='card_title'>Every Season Styled</p>
          </div>
          <hr className='line' />
          <div className='card'>
            <div className='image_wrapper'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='25'
                height='25'
                viewBox='0 0 25 25'
                fill='none'>
                <g clipPath='url(#clip0_486_3104)'>
                  <path
                    d='M1.83398 9.68359V15.6836H15.334V17.1836H0.333984V8.18359H12.4395C12.5566 8.45703 12.6973 8.71875 12.8613 8.96875C13.0254 9.21875 13.2129 9.45703 13.4238 9.68359H1.83398ZM22.7285 8.18359H24.334V17.1836H19.834V15.6836H22.834V9.68359H21.7441C21.9473 9.45703 22.1309 9.21875 22.2949 8.96875C22.459 8.71875 22.6035 8.45703 22.7285 8.18359ZM18.334 9.61328V21.6836L17.584 23.1836L16.834 21.6836V9.61328C16.3965 9.51953 15.9941 9.35938 15.627 9.13281C15.2598 8.90625 14.9434 8.63281 14.6777 8.3125C14.4121 7.99219 14.2051 7.625 14.0566 7.21094C13.9082 6.79688 13.834 6.37109 13.834 5.93359C13.834 5.41797 13.9316 4.93359 14.127 4.48047C14.3223 4.02734 14.5879 3.62891 14.9238 3.28516C15.2598 2.94141 15.6582 2.67188 16.1191 2.47656C16.5801 2.28125 17.0684 2.18359 17.584 2.18359C18.0996 2.18359 18.584 2.28125 19.0371 2.47656C19.4902 2.67188 19.8848 2.94141 20.2207 3.28516C20.5566 3.62891 20.8262 4.02734 21.0293 4.48047C21.2324 4.93359 21.334 5.41797 21.334 5.93359C21.334 6.37891 21.2598 6.80469 21.1113 7.21094C20.9629 7.61719 20.7559 7.98047 20.4902 8.30078C20.2246 8.62109 19.9082 8.89844 19.541 9.13281C19.1738 9.36719 18.7715 9.52734 18.334 9.61328ZM19.834 5.93359C19.834 5.62109 19.7754 5.32812 19.6582 5.05469C19.541 4.78125 19.3809 4.54297 19.1777 4.33984C18.9746 4.13672 18.7363 3.97656 18.4629 3.85938C18.1895 3.74219 17.8965 3.68359 17.584 3.68359C17.2715 3.68359 16.9785 3.74219 16.7051 3.85938C16.4316 3.97656 16.1934 4.13672 15.9902 4.33984C15.7871 4.54297 15.627 4.78125 15.5098 5.05469C15.3926 5.32812 15.334 5.62109 15.334 5.93359C15.334 6.24609 15.3926 6.53906 15.5098 6.8125C15.627 7.08594 15.7871 7.32422 15.9902 7.52734C16.1934 7.73047 16.4316 7.89062 16.7051 8.00781C16.9785 8.125 17.2715 8.18359 17.584 8.18359C17.8965 8.18359 18.1895 8.125 18.4629 8.00781C18.7363 7.89062 18.9746 7.73047 19.1777 7.52734C19.3809 7.32422 19.541 7.08594 19.6582 6.8125C19.7754 6.53906 19.834 6.24609 19.834 5.93359Z'
                    fill='url(#paint0_linear_486_3104)'
                  />
                </g>
                <defs>
                  <linearGradient
                    id='paint0_linear_486_3104'
                    x1='12.334'
                    y1='2.18359'
                    x2='12.334'
                    y2='23.1836'
                    gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#DEC067' />
                    <stop offset='1' stopColor='#EBDDB1' />
                  </linearGradient>
                  <clipPath id='clip0_486_3104'>
                    <rect
                      width='24'
                      height='24'
                      fill='white'
                      transform='translate(0.333984 0.683594)'
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <p className='card_title'>Every Occasion Elevated</p>
          </div>
          <hr className='line' />
          <div className='card'>
            <div className='image_wrapper'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='25'
                height='25'
                viewBox='0 0 25 25'
                fill='none'>
                <path
                  d='M14.166 7.68359L16.666 18.6836L12.666 22.6836L8.66602 18.6836L11.166 7.68359M14.166 7.68359L15.159 5.03459C15.2157 4.88333 15.2349 4.72059 15.215 4.56028C15.1951 4.39998 15.1366 4.24688 15.0446 4.1141C14.9526 3.98132 14.8298 3.87279 14.6868 3.79782C14.5437 3.72285 14.3846 3.68365 14.223 3.68359H11.109C10.9475 3.68365 10.7884 3.72285 10.6453 3.79782C10.5022 3.87279 10.3794 3.98132 10.2874 4.1141C10.1954 4.24688 10.1369 4.39998 10.117 4.56028C10.0971 4.72059 10.1163 4.88333 10.173 5.03459L11.166 7.68359M14.166 7.68359H11.166M14.166 7.68359L19.166 13.1836'
                  stroke='url(#paint0_linear_486_3110)'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <defs>
                  <linearGradient
                    id='paint0_linear_486_3110'
                    x1='13.916'
                    y1='3.68359'
                    x2='13.916'
                    y2='22.6836'
                    gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#DEC067' />
                    <stop offset='1' stopColor='#EBDDB1' />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <p className='card_title'>Formal Wear Refined</p>
          </div>
          <hr className='line' />
          <div className='card'>
            <div className='image_wrapper'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='25'
                viewBox='0 0 24 25'
                fill='none'>
                <g clipPath='url(#clip0_486_3116)'>
                  <path
                    d='M1 23.9702H3.44439M3.44439 23.9702H20.5551M3.44439 23.9702V9.70476M22.9995 23.9702H20.5551M20.5551 23.9702V9.70476M3.44439 9.70476C3.39869 9.67851 3.35386 9.65079 3.30995 9.62165L2.64996 9.18166C2.1834 8.87045 1.83804 8.40827 1.67181 7.87264C1.50558 7.33701 1.52859 6.76051 1.73698 6.23983L2.82963 3.507C3.01111 3.05345 3.32433 2.66468 3.72887 2.39085C4.13342 2.11701 4.61073 1.97067 5.09924 1.9707H18.9003C19.3888 1.97067 19.8661 2.11701 20.2707 2.39085C20.6752 2.66468 20.9884 3.05345 21.1699 3.507L22.2625 6.23983C22.4709 6.76051 22.4939 7.33701 22.3277 7.87264C22.1615 8.40827 21.8161 8.87045 21.3496 9.18166L20.6896 9.62165C20.6457 9.65079 20.6008 9.67851 20.5551 9.70476M3.44439 9.70476C3.83922 9.9328 4.28995 10.0459 4.74567 10.0312C5.20138 10.0165 5.6439 9.87464 6.02322 9.62165L8.33317 8.08168L10.6431 9.62165C11.0448 9.88965 11.5169 10.0327 11.9998 10.0327C12.4826 10.0327 12.9547 9.88965 13.3564 9.62165L15.6663 8.08168L17.9763 9.62165C18.3556 9.87464 18.7981 10.0165 19.2539 10.0312C19.7096 10.0459 20.1603 9.9328 20.5551 9.70476'
                    stroke='url(#paint0_linear_486_3116)'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M14.4435 23.9709V17.8599C14.4435 17.2116 14.1859 16.5899 13.7275 16.1315C13.2691 15.6731 12.6474 15.4155 11.9991 15.4155C11.3508 15.4155 10.729 15.6731 10.2706 16.1315C9.81222 16.5899 9.55469 17.2116 9.55469 17.8599V23.9709'
                    stroke='url(#paint1_linear_486_3116)'
                  />
                </g>
                <defs>
                  <linearGradient
                    id='paint0_linear_486_3116'
                    x1='11.9998'
                    y1='1.9707'
                    x2='11.9998'
                    y2='23.9702'
                    gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#DEC067' />
                    <stop offset='1' stopColor='#EBDDB1' />
                  </linearGradient>
                  <linearGradient
                    id='paint1_linear_486_3116'
                    x1='11.9991'
                    y1='15.4155'
                    x2='11.9991'
                    y2='23.9709'
                    gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#DEC067' />
                    <stop offset='1' stopColor='#EBDDB1' />
                  </linearGradient>
                  <clipPath id='clip0_486_3116'>
                    <rect
                      width='24'
                      height='24'
                      fill='white'
                      transform='translate(0 0.683594)'
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <p className='card_title'>Buy & Rent</p>
          </div>
        </div>
      </div>
      <div className='middle_wrapper'>
        <div className='second_middle_wrapper'>
          <div className='left'>
            <Link to='/'>
              <img src={Logo} alt='Logo' />
            </Link>
          </div>
          <div className='right'>
            <div className='list'>
              <p className='list_title'>Elegance Hub</p>
              <ul>
                {/* <li>
                  <Link to='/shop'>Catalogue</Link>
                </li> */}
                <li>
                  <a
                    href='https://www.collinsclothiers.com/'
                    target='_blank'
                    rel='noopener noreferrer'>
                    Suit/Tuxedo Rentals
                  </a>
                </li>
              </ul>
            </div>
            <div className='list'>
              <p className='list_title'>Miners Apparel</p>
              <ul>
                <li>
                  <Link to='/about'>About</Link>
                </li>
                <li>
                  <Link to='/contact'>Contact Us</Link>
                </li>
              </ul>
            </div>
            <div className='news_box'>
              <div className='input_field'>
                <p className='list_title'>Social Media</p>
              </div>
              <div className='socials'>
                <a
                  aria-label='Facebook'
                  href='https://www.facebook.com/minersapparel/'
                  target='_blank'
                  rel='noopener noreferrer'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='25'
                    viewBox='0 0 24 25'
                    fill='none'>
                    <path
                      d='M22 12.7443C22 7.18759 17.5233 2.68359 12 2.68359C6.47667 2.68359 2 7.18759 2 12.7443C2 17.7669 5.656 21.9289 10.4373 22.6836V15.6529H7.89867V12.7436H10.4373V10.5276C10.4373 8.00626 11.93 6.61293 14.2147 6.61293C15.308 6.61293 16.4533 6.80959 16.4533 6.80959V9.28559H15.1913C13.9493 9.28559 13.5627 10.0616 13.5627 10.8576V12.7443H16.336L15.8927 15.6523H13.5627V22.6836C18.344 21.9289 22 17.7669 22 12.7443Z'
                      fill='#F7F7F7'
                    />
                  </svg>
                </a>
                <a
                  aria-label='Instagram'
                  href='https://www.instagram.com/minersapparel.ng/'
                  target='_blank'
                  rel='noopener noreferrer'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='25'
                    viewBox='0 0 24 25'
                    fill='none'>
                    <path
                      d='M12 9.43359C11.138 9.43359 10.3114 9.776 9.7019 10.3855C9.09241 10.995 8.75 11.8216 8.75 12.6836C8.75 13.5455 9.09241 14.3722 9.7019 14.9817C10.3114 15.5912 11.138 15.9336 12 15.9336C12.862 15.9336 13.6886 15.5912 14.2981 14.9817C14.9076 14.3722 15.25 13.5455 15.25 12.6836C15.25 11.8216 14.9076 10.995 14.2981 10.3855C13.6886 9.776 12.862 9.43359 12 9.43359Z'
                      fill='white'
                    />
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M6.76982 3.76554C10.2458 3.38024 13.7538 3.38024 17.2298 3.76554C19.1288 3.97754 20.6598 5.47254 20.8828 7.37854C21.295 10.9032 21.295 14.4639 20.8828 17.9885C20.6598 19.8945 19.1288 21.3895 17.2308 21.6025C13.7545 21.9879 10.2462 21.9879 6.76982 21.6025C4.87082 21.3895 3.33982 19.8945 3.11682 17.9895C2.70455 14.4646 2.70455 10.9035 3.11682 7.37854C3.33982 5.47254 4.87082 3.97754 6.76982 3.76554ZM16.9998 6.68354C16.7346 6.68354 16.4802 6.78889 16.2927 6.97643C16.1052 7.16397 15.9998 7.41832 15.9998 7.68354C15.9998 7.94875 16.1052 8.20311 16.2927 8.39064C16.4802 8.57818 16.7346 8.68354 16.9998 8.68354C17.265 8.68354 17.5194 8.57818 17.7069 8.39064C17.8945 8.20311 17.9998 7.94875 17.9998 7.68354C17.9998 7.41832 17.8945 7.16397 17.7069 6.97643C17.5194 6.78889 17.265 6.68354 16.9998 6.68354ZM7.24982 12.6835C7.24982 11.4238 7.75027 10.2156 8.64106 9.32478C9.53186 8.43398 10.74 7.93354 11.9998 7.93354C13.2596 7.93354 14.4678 8.43398 15.3586 9.32478C16.2494 10.2156 16.7498 11.4238 16.7498 12.6835C16.7498 13.9433 16.2494 15.1515 15.3586 16.0423C14.4678 16.9331 13.2596 17.4335 11.9998 17.4335C10.74 17.4335 9.53186 16.9331 8.64106 16.0423C7.75027 15.1515 7.24982 13.9433 7.24982 12.6835Z'
                      fill='white'
                    />
                  </svg>
                </a>
                <a
                  aria-label='Google'
                  href='https://www.google.com/maps/place/Miners+Apparel+for+Men/@45.5875922,-62.6477865,17z/data=!4m8!3m7!1s0x4b5c1f3bef7475c1:0xf3e42e2e11c1281!8m2!3d45.5875885!4d-62.6452116!9m1!1b1!16s%2Fg%2F11j01gy521?hl=en-US&entry=ttu'
                  target='_blank'
                  rel='noopener noreferrer'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='25'
                    viewBox='0 0 24 25'
                    fill='none'>
                    <path
                      d='M22 9.18359C22 10.5536 20.88 11.6836 19.5 11.6836C18.12 11.6836 17 10.5536 17 9.18359C17 10.5536 15.88 11.6836 14.5 11.6836C13.12 11.6836 12 10.5536 12 9.18359C12 10.5536 10.88 11.6836 9.5 11.6836C8.12 11.6836 7 10.5536 7 9.18359C7 10.5536 5.88 11.6836 4.5 11.6836C3.12 11.6836 2 10.5536 2 9.18359L3.39 3.76359C3.39 3.76359 3.68 2.68359 4.7 2.68359H19.3C20.32 2.68359 20.61 3.76359 20.61 3.76359L22 9.18359ZM21 12.8836V20.6836C21 21.7836 20.1 22.6836 19 22.6836H5C3.9 22.6836 3 21.7836 3 20.6836V12.8836C3.65738 13.155 4.37572 13.2444 5.07957 13.1423C5.78342 13.0403 6.44679 12.7506 7 12.3036C7.69 12.8536 8.56 13.1836 9.5 13.1836C10.45 13.1836 11.32 12.8536 12 12.3036C12.69 12.8536 13.56 13.1836 14.5 13.1836C15.45 13.1836 16.32 12.8536 17 12.3036C17.68 12.8536 18.56 13.1836 19.5 13.1836C20.03 13.1836 20.54 13.0736 21 12.8836ZM19 18.0136C19 17.8136 19 17.6036 18.95 17.3836L18.92 17.2236H15.95V18.3936H17.76C17.7 18.6136 17.62 18.8336 17.45 19.0136C17.12 19.3436 16.67 19.5236 16.19 19.5236C15.69 19.5236 15.2 19.3136 14.84 18.9636C14.15 18.2536 14.15 17.1036 14.86 16.3836C15.55 15.6836 16.69 15.6836 17.41 16.3536L17.55 16.4836L18.39 15.6336L18.23 15.4936C17.67 14.9736 16.93 14.6836 16.15 14.6836H16.14C15.33 14.6836 14.57 14.9936 14 15.5536C13.41 16.1336 13.08 16.8936 13.08 17.6836C13.08 18.4836 13.39 19.2236 13.96 19.7736C14.554 20.3534 15.35 20.6797 16.18 20.6836H16.2C17 20.6836 17.71 20.3936 18.23 19.8836C18.7 19.4036 19 18.6836 19 18.0136Z'
                      fill='#F8F8F8'
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='lower_wrapper'>
        <div className='second_lower_wrapper'>
          <div className='links_wrapper'>
            <Link to='/privacy'>Privacy Policy</Link>
            <Link to='/terms'>Terms of Service</Link>
          </div>
          <p>
            Designed & Developed by{" "}
            <a
              href='https://webelocity.io'
              target='_blank'
              rel='noopener noreferrer'>
              Webelocity
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
